import * as dayjs from "dayjs";
import * as utc from "dayjs/plugin/utc";
import * as timezone from "dayjs/plugin/timezone";
import * as _ from "lodash";
import {
  calculate_95th,
  convertBitsToBytes,
  convertBpsUnit,
  groupByInterval,
  groupByIntervalTimeline,
} from "./scripts";

dayjs.extend(utc);
dayjs.extend(timezone);

function getValueItem(item: string[]) {
  if (item.includes("icmpping") || item.includes("ifOperStatus")) {
    return Math.random() < 0.7 ? 1 : 0;
  }
  if (item.includes("icmppingloss") || item.includes("icmppingsec")) {
    return parseFloat((Math.random() * 100).toFixed(2));
  }
  return Math.floor(Math.random() * 100_000_000);
}

function generateZabbixData(
  count: number = 100,
  itens?: string[],
  multiple: boolean = false,
) {
  const startDate = dayjs().subtract(count - 1, "minute");
  if (itens?.includes("int") || itens?.includes("float")) {
    return 1;
  }
  if (itens?.includes("boolean")) {
    return true;
  }

  const exampleData = {
    itemName: ["GigabitEthernet0/1"],
    hostName: ["SW-MW-Core-01 - 192.168.1.1"],
    dataInicial: dayjs(Date.now()).subtract(1, "month").startOf("hour"),
    dataFinal: dayjs(Date.now()).startOf("hour"),
    data: Array.from({ length: count }, (_, i) => ({
      itemId: "1234567",
      itemName: "GigabitEthernet0/1",
      hostid: "54321",
      hostName: "SW-MW-Core-01 - 192.168.1.1",
      clock: startDate.add(i, "day").unix(),
      value: getValueItem(itens ?? []),
    })),
  };
  return multiple ? [exampleData] : exampleData;
}

export function evalCode(
  code: string,
  variaveis: { nome: string; itens?: string[]; multiple?: boolean }[] = [],
  setError?: (error: string) => void,
) {
  const dataFinal = dayjs(Date.now()).format("YYYY-MM-DD");
  const dataInicial = dayjs(Date.now())
    .subtract(1, "month")
    .format("YYYY-MM-DD");

  let codigoProcessado = code;

  variaveis.map((variavel) => {
    const content = JSON.stringify(
      generateZabbixData(100, variavel.itens, variavel.multiple),
    );
    const variable = variavel.nome;
    codigoProcessado = codigoProcessado.replaceAll(`_${variable}_`, content);
  });
  codigoProcessado = codigoProcessado.replaceAll("_dataInicial_", dataInicial);
  codigoProcessado = codigoProcessado.replaceAll("_dataFinal_", dataFinal);

  const bloqueados = [
    "require",
    "process",
    "global",
    "child_process",
    "import",
    "fs",
    "while",
  ];
  if (
    bloqueados.some((palavra) =>
      new RegExp(`\\b${palavra}\\b`).test(codigoProcessado),
    )
  ) {
    if (setError) {
      setError("Código contém comandos potencialmente perigosos.");
    }
    return undefined;
  }
  try {
    const dayjs = require("dayjs");
    dayjs.extend(require("dayjs/plugin/utc"));
    dayjs.extend(require("dayjs/plugin/timezone"));
    dayjs.extend(require("dayjs/plugin/duration"));

    const context = {
      dayjs,
      groupByInterval,
      groupByIntervalTimeline,
      calculate_95th,
      convertBpsUnit,
      convertBitsToBytes,
    };

    const result = eval(`
      (function(context) {
        "use strict";
         const dayjs = context.dayjs;
         const groupByInterval = context.groupByInterval;
         const groupByIntervalTimeline = context.groupByIntervalTimeline;
         const calculate_95th = context.calculate_95th;
         const convertBpsUnit = context.convertBpsUnit;
         const convertBitsToBytes = context.convertBitsToBytes;
        ${codigoProcessado}
      })(context)
    `);
    return result;
  } catch (e) {
    if (setError) {
      if (e instanceof Error) {
        setError(`Erro no Código: ${e.message}`);
      } else {
        setError(`Erro no Código: ${String(e)}`);
      }
    }
    return undefined;
  }
}

export function evalView(
  codeResult: Record<string, any>,
  view: string,
  dayjs: any,
  setError: (error: string) => void,
  i?: number,
) {
  let viewProcessed = view;
  const editedCode: { [key: string]: any } = {
    titulo: i === 0 ? "Meu Título" : "",
    ...codeResult,
  };
  Object.keys(editedCode).map((key) => {
    const content = JSON.stringify(editedCode[key]);
    viewProcessed = viewProcessed.replaceAll(`_${key}_`, content);
  });

  viewProcessed = viewProcessed.replace(
    /([{,]\s*)([a-zA-Z0-9_]+-[a-zA-Z0-9_-]+)\s*(?=:)/g,
    '$1"$2"',
  );

  const context = {
    dayjs,
    convertBpsUnit,
    convertBitsToBytes,
  };

  try {
    const result = eval(`
      (function(context) {
        "use strict";
        const dayjs = context.dayjs;
        const convertBpsUnit = context.convertBpsUnit;
        const convertBitsToBytes = context.convertBitsToBytes;
        return JSON.stringify(${viewProcessed})
      })(context)
    `);
    return result;
  } catch (e) {
    if (e instanceof Error) {
      setError(`Erro no View: ${e.message}`);
    } else {
      setError(`Erro no View: ${String(e)}`);
    }

    return undefined;
  }
}
